import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCTnwzIV7uKfX50Vq2MnkZK2lIbaXdrFZY",
  authDomain: "craftschool.firebaseapp.com",
  projectId: "craftschool",
  storageBucket: "craftschool.firebasestorage.app",
  messagingSenderId: "1057326449494",
  appId: "1:1057326449494:web:36ec42dcf17d717c4a8cf7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
